// extracted by mini-css-extract-plugin
export var card = "_bi-c";
export var checkmark = "_bi-k";
export var childrenContainer = "_bi-6";
export var container = "_bi-b";
export var disabled = "_bi-9";
export var disabledChildren = "_bi-a";
export var focused = "_bi-1";
export var gray = "_bi-r";
export var green = "_bi-o";
export var icon = "_bi-g";
export var iconWrapper = "_bi-8";
export var imageCircle = "_bi-s";
export var large = "_bi-5";
export var lg = "_bi-j";
export var listItemContainer = "_bi-0";
export var md = "_bi-i";
export var medium = "_bi-4";
export var menu = "_bi-f";
export var red = "_bi-p";
export var rightArea = "_bi-7";
export var sectionContainer = "_bi-e _bi-b";
export var selected = "_bi-d";
export var sm = "_bi-h";
export var small = "_bi-3";
export var statusDot = "_bi-n";
export var statusDotContainer = "_bi-m";
export var text = "_bi-l";
export var xs = "_bi-2";
export var yellow = "_bi-q";